import { jsx as _jsx } from "react/jsx-runtime";
import { useLayoutEffect, useRef } from "react";
import { Chip, MeObjektliste, MeObjektzeile } from "../me/index.js";
import "./Objektliste.css";
/**
 * Die Liste — `me-objektliste` (`role="listbox"`) mit dem Namen der Liste.
 *
 * Roving Tabindex, Pfeil hoch/runter (ohne Umlauf), Home/Ende und das `preventDefault`
 * gegen das Mitrollen der Seite macht das ELEMENT; der eigene DOM-Code dafür ist entfallen.
 */
export function Objektliste(p) {
    return (_jsx(MeObjektliste, { className: "ki-objekt__liste", "aria-label": p.label, children: p.children }));
}
export function Objektzeile(p) {
    const marken = p.marken ?? [];
    /*
     * `me-gewaehlt` horcht hier im LAYOUT-Effekt, nicht über das Prop `onGewaehlt` der Hülle
     * (ME-Etappe 2, Fixrunde F2). Die Hülle meldet ihren Zuhörer in einem PASSIVEN Effekt an
     * (me-design react/ereignis.ts), und der läuft nach einer Aktualisierung ausserhalb von
     * `act` — Liste vom Server geladen, Zeilen zum ersten Mal gezeichnet — erst nach dem
     * Malen. Ein Klick in dieser Lücke ging verloren: Die Zeile steht da, das Element meldet
     * `me-gewaehlt`, aber niemand hört zu (belegt in web/test/bereichArtikel.test.tsx,
     * „Zurück-Taste", unter Last rot). Derselbe Grund wie beim Horcher in MeSchale.tsx.
     */
    const wirt = useRef(null);
    const oeffnen = useRef(p.onOeffnen);
    oeffnen.current = p.onOeffnen;
    useLayoutEffect(() => {
        const el = wirt.current;
        if (el === null)
            return undefined;
        const zuhoerer = () => { oeffnen.current(); };
        el.addEventListener("me-gewaehlt", zuhoerer);
        return () => el.removeEventListener("me-gewaehlt", zuhoerer);
    }, []);
    return (_jsx(MeObjektzeile, { ref: wirt, name: p.name, ...(p.kennung === undefined ? {} : { kennung: p.kennung }), ...(p.meta === undefined ? {} : { meta: p.meta }), ...(p.status === undefined ? {} : { status: p.status.text, statusArt: p.status.art }), gewaehlt: p.gewaehlt, aktuell: p.gewaehlt, gesperrt: p.gesperrt === true, ...(p.ersetzt === true ? { zustand: "ersetzt" } : {}), umbruch: p.umbruch === true, ...(p.ausrichtung === undefined ? {} : { ausrichtung: p.ausrichtung }), ...(p.zaehler === undefined ? {} : { zaehler: p.zaehler }), "aria-label": p.ariaLabel, icon: p.vorn, chips: marken.length === 0 ? undefined : marken.map((marke) => {
            if (typeof marke === "string")
                return _jsx(Chip, { children: marke }, marke);
            return (_jsx(Chip, { ...(marke.farbe === undefined ? {} : { farbe: marke.farbe }), ...(marke.className === undefined ? {} : { className: marke.className }), ...(marke.style === undefined ? {} : { style: marke.style }), children: marke.text }, marke.text));
        }), zusatz: p.children }));
}
//# sourceMappingURL=Objektliste.js.map